import { render } from "./Eastern tobacco company.vue?vue&type=template&id=73b35c1e&scoped=true"
const script = {}

import "./Eastern tobacco company.vue?vue&type=style&index=0&id=73b35c1e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-73b35c1e"

export default script